<div class="flex justify-center p-8">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
    <app-note *ngIf="!isLoading" [text]="optInMessage" [severity]="severity"></app-note>
</div>